import ConversationListItem from './ConversationListItem'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import { parseUTC } from '../../utils/dateUtils'

function getTimeGroup(dateStr) {
  if (!dateStr) return 'Older'
  const d = parseUTC(dateStr)
  if (!d || isNaN(d.getTime())) return 'Older'
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterday = new Date(today.getTime() - 86400000)
  const weekAgo = new Date(today.getTime() - 604800000)

  if (d >= today) return 'Today'
  if (d >= yesterday) return 'Yesterday'
  if (d >= weekAgo) return 'This Week'
  return 'Older'
}

export default function ConversationList({
  conversations, selectedId, onSelect, onLoadMore, hasMore, isLoading, checkedIds, onCheck
}) {
  if (isLoading && conversations.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <ArrowPathIcon className="h-5 w-5 text-slate-300 animate-spin" />
      </div>
    )
  }

  if (conversations.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-4">
        <p className="text-xs text-slate-400 text-center">No conversations found</p>
      </div>
    )
  }

  // Group by time
  const groups = {}
  conversations.forEach((conv) => {
    const group = getTimeGroup(conv.last_message_at)
    if (!groups[group]) groups[group] = []
    groups[group].push(conv)
  })

  const groupOrder = ['Today', 'Yesterday', 'This Week', 'Older']

  return (
    <div className="flex-1 overflow-y-auto">
      {groupOrder.map((group) => {
        if (!groups[group]?.length) return null
        return (
          <div key={group}>
            <div className="px-3 py-1.5 bg-slate-50 text-[10px] font-semibold text-slate-500 uppercase tracking-wider sticky top-0 z-10">
              {group}
            </div>
            {groups[group].map((conv) => (
              <ConversationListItem
                key={conv.id}
                conversation={conv}
                isSelected={selectedId === conv.id}
                onClick={() => onSelect(conv)}
                isChecked={checkedIds.has(conv.id)}
                onCheck={onCheck}
              />
            ))}
          </div>
        )
      })}
      {hasMore && (
        <button
          onClick={onLoadMore}
          disabled={isLoading}
          className="w-full py-3 text-xs text-brand-600 hover:bg-brand-50 transition-colors font-medium"
        >
          {isLoading ? 'Loading...' : 'Load More'}
        </button>
      )}
    </div>
  )
}
